export type DownloadOS = 'windows' | 'macos' | 'linux';

export const DOWNLOAD_VERSION = import.meta.env.VITE_DOWNLOAD_VERSION || '1.0.0';

const RAW_BASE_URL = import.meta.env.VITE_DOWNLOAD_BASE_URL || '/downloads';

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
}

const BASE_URL = normalizeBaseUrl(RAW_BASE_URL);

export function buildDownloadUrl(fileName: string): string {
  return `${BASE_URL}/v${DOWNLOAD_VERSION}/${fileName}`;
}

export const DOWNLOAD_FILES = {
  windows: {
    primary: {
      label: '.exe Installer',
      file: 'noteon-setup-win.exe',
    },
    alternatives: [
      { label: '.msi Package', file: 'noteon-setup-win.msi' },
      { label: 'Portable .zip', file: 'noteon-portable-win.zip' },
    ],
  },
  macos: {
    primary: {
      label: 'Universal .dmg',
      file: 'noteon-mac-universal.dmg',
    },
    alternatives: [
      { label: 'Intel only', file: 'noteon-mac-intel.dmg' },
      { label: 'Apple Silicon', file: 'noteon-mac-arm64.dmg' },
    ],
  },
  linux: {
    primary: {
      label: '.deb (Ubuntu/Debian)',
      file: 'noteon-linux-amd64.deb',
    },
    alternatives: [
      { label: '.rpm (Fedora/RHEL)', file: 'noteon-linux-x86_64.rpm' },
      { label: 'AppImage', file: 'noteon-linux-x86_64.AppImage' },
      { label: '.tar.gz', file: 'noteon-linux-x64.tar.gz' },
    ],
  },
} as const;

export function getPrimaryDownloadUrl(os: DownloadOS): string {
  return buildDownloadUrl(DOWNLOAD_FILES[os].primary.file);
}

export function getDownloadUrls(os: DownloadOS): { label: string; url: string; primary?: boolean }[] {
  const primary = {
    label: DOWNLOAD_FILES[os].primary.label,
    url: buildDownloadUrl(DOWNLOAD_FILES[os].primary.file),
    primary: true,
  };
  const alternatives = DOWNLOAD_FILES[os].alternatives.map(item => ({
    label: item.label,
    url: buildDownloadUrl(item.file),
  }));
  return [primary, ...alternatives];
}
